import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';
import { DeleteEvent } from 'src/@core/interfaces/delete-event';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { AssignAdminDialogComponent } from 'src/app/modules/employment/assign-admin-dialog/assign-admin-dialog.component';
import { AssignJobAdminComponent } from 'src/app/modules/employment/assign-job-admin/assign-job-admin.component';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/components/confirm-delete-dialog/confirm-delete-dialog.component';
import { v4 as uuid } from 'uuid';
import Swal from 'sweetalert2';

@Component({
  selector: 'hour4u-admin-job-burger-menu',
  templateUrl: './job-burger-menu.component.html',
  styleUrls: ['./job-burger-menu.component.scss']
})
export class JobBurgerMenuComponent implements OnInit {
  @Input() row: any;
  @Input() status: any;
  @Input() roles: any;
  @Input() permissions: any;
  @Input() entityTypes?: any;

  @Output() dataRefresh = new EventEmitter();
  profile = this.appService.getCurrentAccount();
  isExporting = false;

  constructor(
    private router: Router,
    private jobService: JobService,
    private dialog: MatDialog,
    private appService: AppService,
    private notify: NotificationService
  ) { }

  ngOnInit() {
  }

  clone(object: any): void {
    const oldProjectId = object && object.project_id;
    if (!oldProjectId) {
      this.notify.showMessage('Unable to clone: project id missing!', 3000);
      return;
    }

    const newProjectId = uuid();
    const payload = {
      entityId: this.profile.entity.id,
      oldProjectId,
      newProjectId
    };

    this.jobService.cloneHoaProject(payload).subscribe(
      () => {
        this.notify.showMessage('Project cloned!', 2000);
        this.dataRefresh.emit();
      },
      (err) => {
        console.error('Error cloning project:', err);
        this.notify.showMessage('Error cloning project!', 3000);
      }
    );
  }


  update(object: any): void {
    console.log(object)
    const data = {
      title: 'Edit Template',
      data: object
    };
    const navigationExtras: NavigationExtras = {
      state: { data: JSON.stringify(data) },
    };
    // this.router.navigate(['add-edit-project'], navigationExtras);
    this.router.navigateByUrl('/job/create-new-project/' + object.project_id + '/edit');
  }

  // Delete template
  deleteTemplate(row) {
    Swal.fire({
      //icon: 'warning',
      title: '<img src="assets/trash-white.svg" style="width: 40px; height: 40px; margin: auto; margin-bottom: 20px;"> Are you sure?',
      html: '<p class="secondary">This action cannot be undone.</p>',
      showConfirmButton: true,
      confirmButtonText: "Delete",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      customClass: {
        popup: 'c-card-wrap',
        confirmButton: 'warning-btn',
        cancelButton: 'secondary-btn',
        title: 'secondary',
      },
      preConfirm: () => {  // Change 'confirm' to 'preConfirm'
        let obj = {
          "entityId": row.entity_id,
          "projectId": row.project_id
        };
        return this.jobService.deleteProject(obj).toPromise();
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.notify.showMessage('Project deleted!', 3000);
        this.dataRefresh.emit();
      } else {
        this.notify.showMessage('Unable to delete project!', 3000);
      }
    });

  }

  // create Work Order
  createWorkOrder(job: any) {
    const navigationExtras: NavigationExtras = {
      queryParams: { 'jobId': job.id, 'jobTypeId': job.jobTypeId, 'employerId': job.employerId }
    }
    this.router.navigate(['/enterprise-admin/create-work-order'], navigationExtras);
  }

  // ASSIGN ADMIN DIALOG
  assignAgency(data): void {
    // const employmentAdmin = new EmploymentAdministration();
    // employmentAdmin.employmentId = id;
    const dialogRef = this.dialog.open(AssignJobAdminComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }

  // ASSIGN enterprise DIALOG
  assignEnterprises(data): void {
    // const employmentAdmin = new EmploymentAdministration();
    // employmentAdmin.employmentId = id;
    const dialogRef = this.dialog.open(AssignAdminDialogComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }

  exportSummary(row: any) {
    const projectId = row && row.project_id;

    if (!projectId) {
      this.notify.showMessage('Project ID is missing', 3000);
      return;
    }
    if (this.isExporting) {
      return;
    }

    this.isExporting = true;
    this.notify.showMessage('Preparing your export… this can take up to a couple of minutes for large projects.', 4000);

    this.jobService.exportConnectedLeadsExcel(projectId).subscribe(
      (result) => {
        this.isExporting = false;
        this.downloadExportedFile(result.downloadUrl, result.filename);
      },
      (err) => {
        this.isExporting = false;
        this.notify.showMessage(this.getExportErrorMessage(err), 5000);
      }
    );
  }

  private getExportErrorMessage(err: any): string {
    if (err === 'EXPORT_TIMEOUT') {
      return 'Export is taking longer than expected. Please try again.';
    }
    return typeof err === 'string' ? err : 'Export failed. Please try again.';
  }

  private downloadExportedFile(downloadUrl: string, filename: string): void {
    // downloadUrl is a presigned S3 URL — do NOT attach x-api-key or any auth headers,
    // they break the S3 signature. Fetch as a blob to force a download with the right
    // filename, falling back to opening the URL directly if the blob fetch fails.
    fetch(downloadUrl)
      .then((response) => {
        if (!response.ok) throw new Error('Download failed');
        return response.blob();
      })
      .then((blob) => {
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename;
        a.rel = 'noopener';
        a.click();
        URL.revokeObjectURL(objectUrl);
      })
      .catch(() => {
        window.open(downloadUrl, '_blank', 'noopener,noreferrer');
      });
  }
}
